"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.crunch = exports.isVersionedCrunchedData = void 0;
const tslib_1 = require("tslib");
const JSON_1 = require("./JSON");
const v1 = (0, tslib_1.__importStar)(require("./v1"));
const v2 = (0, tslib_1.__importStar)(require("./v2"));
function isVersionedCrunchedData(data) {
  return (0, JSON_1.isObject)(data) && data.version != null;
}
exports.isVersionedCrunchedData = isVersionedCrunchedData;
function crunch(data, version = 1) {
  if (version === 1) {
    return v1.crunch(data);
  }
  if (version === 2) {
    return {
      version,
      crunched: v2.crunch(data)
    };
  }
  // Unknown version numbers default to version 1.
  return v1.crunch(data);
}
exports.crunch = crunch;